import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={19}
    height={19}
    viewBox={'0 0 19 19'}
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#9D9EC5'}
      d="M12.11 9.721a5.138 5.138 0 0 0 1.51-7.11 5.138 5.138 0 0 0-7.11-1.51 5.137 5.137 0 0 0 0 8.62 8.995 8.995 0 0 0-6.2 8.55H1.6c0-4.26 3.45-7.71 7.71-7.71s7.71 3.45 7.71 7.71h1.29c0-3.89-2.5-7.34-6.2-8.55Zm-6.66-4.31c0-2.13 1.73-3.86 3.86-3.86s3.86 1.73 3.86 3.86-1.73 3.86-3.86 3.86-3.86-1.73-3.86-3.86Z"
    />
  </Svg>
);
export default SvgComponent;
